var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45331 4.86784L15.699 11.0268C16.1003 11.4225 16.1003 12.0641 15.699 12.4599C15.2977 12.8556 14.6471 12.8556 14.2457 12.4599L7.99996 6.30128L1.75421 12.4599C1.38156 12.8274 0.793932 12.8537 0.390612 12.5387L0.30099 12.4599C-0.10033 12.0643 -0.10033 11.4226 0.30099 11.0269L6.54781 4.86893L6.54675 4.86784L8.00003 3.43475L9.45331 4.86784Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveUp);
export default __webpack_public_path__ + "static/media/move-up.651f5e227d29aea1a0356b340aca1136.svg";
export { ForwardRef as ReactComponent };